import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const MetaPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Meta & Instagram"
      description="Step-by-step instructions for adding your Upfeed product feed to Meta Commerce Manager to run Dynamic Ads on Facebook and Instagram."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Meta &amp; Instagram</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Meta
            Commerce Manager so you can run Dynamic Ads on Facebook and
            Instagram.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>
                A Meta Business Manager account with Commerce Manager access.
              </li>
            </ul>
          </div>

          <h2>Adding the feed to Meta Commerce Manager</h2>
          <ul>
            <li>Copy the product feed URL from the app homepage.</li>
            <li>
              Go to{" "}
              <a href="https://business.facebook.com" target="_blank" rel="noreferrer">
                Meta Business Manager
              </a>{" "}
              &gt; Commerce Manager and create a new catalog (or click on your
              existing catalog).
            </li>
            <li>In the catalog click on 'Product Data Sources'.</li>
            <li>Click 'Add Items' and then select 'Use Bulk Upload'.</li>
            <li>
              Select 'Scheduled Feed' and on the next screen enter the feed URL
              from the app.
            </li>
            <li>Set the scheduled automated upload at a time past 5am EST.</li>
            <li>
              Enter a feed name and your store's currency, then click the
              'Upload' button.
            </li>
          </ul>

          <h2>Running Dynamic Ads</h2>
          <p>
            Once your catalog is populated, go to Ads Manager and create a new
            campaign with the 'Catalogue Sales' objective. Select your product
            catalog and set up your audience and budget to start running Dynamic
            Ads on Facebook and Instagram.
          </p>

          <RelatedPlatforms currentSlug="meta" />
        </div>
      </div>
    </div>
  </Layout>
)

export default MetaPage
